import '../../modules/mode-components';

import * as angular from 'angular';

const selectNavigatorDirective = function ($window) {
  return {
    link: function ($scope: angular.IScope, $elem: JQuery, attrs) {
      $elem.on('change', (_event) => {
        $window.location.href = $elem.val();
      });
    },
  };
};

selectNavigatorDirective.$inject = ['$window'];

angular.module('mode.components').directive('selectNavigator', selectNavigatorDirective);
